var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-input',_vm._g(_vm._b({attrs:{"rules":_vm.computedRules}},'v-input',_vm.fieldProps,false),_vm.$listeners),[_c('div',{staticClass:"k-field-wrapper codemirror-text-area my-2",class:this.grid},[_c('codemirror',_vm._g(_vm._b({attrs:{"label":_vm.translatedLabel,"options":_vm.cmOption}},'codemirror',_vm.fieldProps,false),_vm.$listeners))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }